import { _addEventListener } from "../eventHelper";
import { disableAttributes, toggleStateElement } from "../AccesibilityHelper";

const selectedParents = ['[role="tablist"]'];
export const automateAriaSelectedElements = () => {
    let ariaSelectedElements = document.querySelectorAll("[aria-selected]");
    ariaSelectedElements.forEach((ariaSelectedElement) => {
        _addEventListener(ariaSelectedElement, "click", handleAriaSelectedClick);
    });
};

export const handleAriaSelectedClick = (event) => {
    let clickedElement = event.currentTarget;
    const parent = clickedElement.closest(selectedParents.join(","));
    disableAttributes("aria-selected", parent);
    toggleStateElement(clickedElement, "aria-selected");
};
